import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

function Footer() {
  useEffect(() => {
    const yearSpan = document.getElementById('currentYear');
    if (yearSpan) {
      yearSpan.textContent = new Date().getFullYear().toString();
    }
  }, []);



  return (
    <footer className="footer-new">
      <div className="container">
        <div className="footer-cta-section text-center">
          <h2 className="footer-cta-heading anton">Schedule Your Free Demo</h2>
          <p className="footer-cta-description">
            Take a quick demo and see how companies increased <br></br> productivity and transformed team performance with LOOV.
          </p>
          <a className="schedule-footer fs-14  text-decoration-none" href='https://view.loov.in/sign-up'>
            Schedule Your Free Trail
          </a>
         
        </div>

        <div className="footer-separator"></div>

        <div className="footer-logo-section text-center">
          <div className="footer-logo-new">
            <Link className="navbar-brand" to="/">
              <img src={require("../assets/loov-logo-1.svg").default} alt="LOOV Logo" id="navbar-logo" />
            </Link>
          </div>
           <div className="footer-copyright-new">
              <p className="mb-0">
                © <span id="currentYear"></span> LOOV. Made for Productivity. Product by{' '}
                <a href="https://msitpark.org/" target='_blank' rel="noopener noreferrer" className="footer-link">MS IT Park</a>.
              </p>
            </div>
      
        </div>

        <div className="footer-bottom-new">
          <div className="footer-bottom-content">
            <div className="footer-social-icons">
              <a href="https://www.facebook.com/msitpark.pvtltd/" target='_blank' rel="noopener noreferrer" className="footer-social-icon">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/msitpark/" target='_blank' rel="noopener noreferrer" className="footer-social-icon ">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/ms-it-park" target='_blank' rel="noopener noreferrer" className="footer-social-icon">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>

           

            <div className="footer-policy-links">
              <Link to="/privacyandpolicy" className="footer-link">Policies</Link>
              <Link to="/refundpolicy" className="footer-link">Refund Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
